module.exports = __webpack_public_path__ + "static/img/icon_appointment_dark.b76eb01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_appointment_dark.png
// module id = 585
// module chunks = 1